import { formatLocalDateTime } from "../../../utils/formatDate";

export default function EtapaProgress({ etapas = [], etapaAtualCodigo, status, executores = [] }) {
    const indiceAtual = etapas.findIndex(e => e.codigo === etapaAtualCodigo);
    const finalizada = status === "FINALIZADA";
    const cancelada = status === "CANCELADA";

    function estadoDaEtapa(index) {
        if (cancelada) return "cancelada";
        if (finalizada) return "concluida";
        if (indiceAtual === -1) return "futura";
        if (index < indiceAtual) return "concluida";
        if (index === indiceAtual) return "atual";
        return "futura";
    }

    function getExecutorDaEtapa(etapaCodigo) {
        return executores.find(
            executor => executor.etapaOrigem === etapaCodigo
        );
    }

    if (etapas.length === 0) return null;

    return (
        <div className="w-full overflow-x-auto">
            <div className="flex items-start min-w-max px-1 pt-1">
                {etapas.map((etapa, index) => {
                    const estado = estadoDaEtapa(index);
                    const isLast = index === etapas.length - 1;

                    const executor = getExecutorDaEtapa(etapa.codigo);

                    return (
                        <div  key={etapa.codigo} className="flex items-start">
                            <div title={
                                        executor
                                            ? `Executor: ${executor.usuarioNome} \n${executor.dataHora ? formatLocalDateTime(executor.dataHora): null}`
                                            : "Executor não informado"
                                    } className="flex flex-col items-center gap-1.5 w-20">
                                <div
                                                                    
                                    className={`w-3.5 h-3.5 rounded-full border-2 ${estado === "concluida" ? "bg-success border-success"
                                            : estado === "atual" ? "bg-primary border-primary ring-4 ring-primary/20"
                                                : estado === "cancelada" ? "bg-destructive/30 border-destructive/40"
                                                    : "bg-muted border-border"
                                        }`}
                                />
                                <span

                                    className={`text-[11px] text-center leading-tight cursor-help ${
                                        estado === "atual"
                                            ? "text-primary font-semibold"
                                            : estado === "concluida"
                                                ? "text-success font-medium"
                                                : "text-muted-foreground"
                                    }`}
                                >
                                    {etapa.label}
                                </span>
                            </div>

                            {!isLast && (
                                <div className={`h-0.5 w-6 md:w-10 mt-[6px] ${estado === "concluida" ? "bg-success" : "bg-border"}`} />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
